import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';
import { SearchComponent } from '../../components/common/search/search.component';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { GetAccountDetailsDto } from '../../models/account/account.models';
import { SubscriptionSearchModel, SubscriptionSummaryDto } from '../../models/subscriptions/subscription.search.models';
import { AccountService } from '../../services/account.service';
import { SubscriptionService } from '../../services/subscription.service';


@Component({
    selector: 'account-subscriptions',
    template: require('./subscriptions.component.html'),
    styles: [require('./personal.account.shared.css'), require('./subscriptions.component.css')]
})
export class SubscriptionsComponent extends SearchComponent<SubscriptionSearchModel,
    SubscriptionSummaryDto> implements OnInit, OnDestroy {

    @Output() hasData = new EventEmitter<boolean>();

    showSubscriptionOptions: boolean;

    user: LoggedInUser;
    subscribed: boolean;
    isTeamMember: boolean;
    accountStatus: string;
    renewalTypeLabel: string | null = null;

    constructor(private subscriptionService: SubscriptionService,
        configuration: Configuration,
        helpers: Helpers,
        private router: Router,
        private readonly accountService: AccountService,
        loggedInUserService: LoggedInUserService) {
        super(new SubscriptionSearchModel(configuration), subscriptionService, helpers);

        this.user = loggedInUserService.getCurrentUser();
        this.subscribed = this.user ? !this.user.canAdHoc('notSubscribed') : false;
        this.isTeamMember = !!this.user && this.user.role === 'Tender Team Member';
        this.showSubscriptionOptions = false;

        if (this.user) {
            this.request.customerId = this.user.userId;
        } else {
            this.request.customerId = -1;
        }

        this.request.sortProperty = 'ExpiryDate';
        this.request.descending = true;
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');
        this.accountService.getAccountDetails().subscribe((result: GetAccountDetailsDto) => {
            this.accountStatus = result ? result.accountStatus : '';
        });
        super.ngOnInit();
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    searchCallback(results) {
        super.searchCallback(results);

        var hasResults = this.results && this.results.data && this.results.data.length > 0;

        this.hasData.emit(hasResults); 

        if (hasResults) {
            this.renewalTypeLabel = this.getRenewalTypeLabel(this.results.data[0]);
            this.results.data.forEach((element) => {
                if (element.firstExpiryWarningSent) {
                    this.showSubscriptionOptions = true;
                }
            });
        } else {
            this.renewalTypeLabel = null;
        }
    }

    private getRenewalTypeLabel(subscription: SubscriptionSummaryDto): string {
        if (subscription.subscriptionStatus &&
            subscription.subscriptionStatus.toLowerCase() === 'cancelled') {
            return 'No Renewal';
        }
        if (subscription.automaticRenewal) {
            return 'Auto-renew';
        }
        return 'Annual Invoice';
    }

    canPayByCard(subscription: SubscriptionSummaryDto): boolean {
        return (subscription.subscriptionStatus || '').toLowerCase() === 'pending';
    }

    getPaymentMethodLabel(subscription: SubscriptionSummaryDto): string {
        const method = (subscription.paymentType || '').trim().toLowerCase();
        if (method === 'bacs') {
            return 'BACS';
        }
        if (method === 'phone') {
            return 'Phone Payment';
        }
        if (method === 'card') {
            return subscription.automaticRenewal ? 'Automatic Card Renewal' : 'Card Payment';
        }
        return subscription.paymentType || '';
    }

    showPaymentDetails(summary: SubscriptionSummaryDto) {
        this.hideInvoices(summary);
        summary.showPayments = true;
    }

    hidePaymentDetails(summary: SubscriptionSummaryDto) {
        summary.showPayments = false;
    }

    showInvoices(summary: SubscriptionSummaryDto) {
        this.hidePaymentDetails(summary);
        summary.showInvoices = true;
    }

    hideInvoices(summary: SubscriptionSummaryDto) {
        summary.showInvoices = false;
    }

    downloadInvoice(id: number) {
        this.subscriptionService.downloadInvoice(id);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/subscriptions.component.ts